import { combineReducers } from 'redux';

import settingsReducer from './settings.reducer.js';
import themesReducer from './themes.reducers.js';
import dialogsReducer from './dialogs.reducer.js';
import refetchReducer from './refetch.reducer';
import authInfoReducer from './authInfo.reducer';

export default combineReducers({
  settings: settingsReducer,
  theme: themesReducer,
  dialogs: dialogsReducer,
  refetch: refetchReducer,
  authInfo: authInfoReducer
});
